import React from 'react';
// import DashboardLayout from '../components/Layouts/DashboardLayout';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import EditInventoryForm from '../components/DashboardComponents/EditInventoryForm';
const EditInventory = () => {
 return (
    <>
{/* <InnerBanner pageKey="editInventory" /> */}

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <EditInventoryForm/> 
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default EditInventory;